import { render, staticRenderFns } from "./ProjectIrrigationSubmissionForm.vue?vue&type=template&id=c4a78d70"
import script from "./ProjectIrrigationSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectIrrigationSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports